import { useEffect, useState } from "react";
import { GoTODocketHeader } from "./GoTODocketHeader";

import "./GoToDocket.css";
import { Toster } from "../../../../components/Toster/Toster";
import { DynamicTabb } from "../../../../components/DynamicTab/DynamicTab";

export const GOToDocket = () => {
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "",
    message: "",
  });

  return (
    <>
      <Toster message={toastConfig.message} type={toastConfig.type} visible={toastConfig.isVisible} />
      <div className="particcipentPage">
        <DynamicTabb />
        <GoTODocketHeader toastConfig={toastConfig} setToastConfig={setToastConfig} />
      </div>
    </>
  );
};
